import { memo, useMemo } from 'react';
import { t } from 'i18next';

import { Dimensions } from '@/modules/common/components/Dimensions';
import { Accordion } from '@/modules/common/components/Accordion';
import { NumUtils } from '@/modules/common/utils';
import { useAppStore } from '@/modules/app/store/useAppStore';

type Props = {
  x: number;
  y: number;
  length: number;
  width: number;
  angle: number;
  disabled?: boolean;
  onXChange: (value: number) => void;
  onYChange: (value: number) => void;
  onAngleChange: (value: number) => void;
};

function TemplateDimensionsComponent({
  x,
  y,
  length,
  width,
  angle,
  disabled,
  onXChange,
  onYChange,
  onAngleChange,
}: Props) {
  const mode = useAppStore((state) => state.mode);

  const isDisabled = useMemo(() => {
    if (disabled !== undefined) return disabled;

    return mode !== 'EDITABLE';
  }, [disabled, mode]);

  return (
    <Accordion
      title={t<string>('interface:properties.dimensions.label', 'Dimensions')}
      unmountOnExit
      defaultExpanded
      sx={{ px: 2 }}
    >
      <Dimensions
        disabled={isDisabled}
        disableLength
        disableWidth
        x={NumUtils.metersToMmRounded(x)}
        y={NumUtils.metersToMmRounded(y)}
        length={NumUtils.metersToMmRounded(length)}
        width={NumUtils.metersToMmRounded(width)}
        angle={angle}
        onXChange={onXChange}
        onYChange={onYChange}
        onAngleChange={onAngleChange}
      />
    </Accordion>
  );
}

export const TemplateDimensions = memo(TemplateDimensionsComponent);
